import { DependencyList, useEffect, useRef } from 'react';

export function useScrollToBottom(dependency: DependencyList) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTo({
        top: ref.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, dependency);

  return ref;
}
